<div class="docs-card">
  <div class="doc-insidecard">

    <!-- ===== TOP HEADER ===== -->
    <div class="top-header">

      <div class="header-left">
        <wm-common-text class="head-title" [data]="{ text: 'Compliance Documents' }">
        </wm-common-text>

        <wm-common-text class="workflow-name" [data]="{ text: workflowName }">
        </wm-common-text>
      </div>

      <button mat-icon-button class="toggle-btn" (click)="toggleCard()">
        <mat-icon>
          {{ isOpen ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>

    </div>

    <div *ngIf="isOpen">

      <!-- ===== DOCUMENT ROW ===== -->
      <div class="docs-row">
        <wm-common-text class="section-title" [data]="{ text: 'Documents' }">
        </wm-common-text>

        <button mat-flat-button class="upload-btn" (click)="onUploadClick()" *ngIf="!showUploadSection">
          UPLOAD DOCUMENT
        </button>
      </div>

      <!-- ===== SUBTEXT ===== -->
      <div class="docs-subtext">
        <wm-common-text [data]="{ text: 'Use the upload button to add new documents' }">
        </wm-common-text>
      </div>

      <!-- ================= UPLOAD SECTION ================= -->
      <div class="upload-section" *ngIf="showUploadSection">

        <!-- Added by Amisha on 07/30/2026: Allow multiple compliance documents to be selected and uploaded in one batch. -->
        <wm-upload [validDocumentTypes]="'pdf'" [allowMultipleFiles]="true" [pathSegments]="[parentId]"
          [showUploadedFilesList]="true" [deleteStoredDocument]="false" [showRemove]="true"
          (uploadComplete)="onUploadComplete($event)">
        </wm-upload>

        <div class="upload-actions">

          <button mat-flat-button class="cancel-btn" (click)="onCancelUpload()">
            CANCEL
          </button>

          <button mat-flat-button class="save-btn" [disabled]="!uploadedDocsBatch.length" (click)="onSaveUpload()">
            SAVE
          </button>



        </div>

      </div>


      <!-- ================= TABLE ================= -->

      <div class="docs-table-scroll">
      <table class="docs-table">
        <colgroup>
          <col class="docs-col-file">
          <col class="docs-col-uploaded-on">
          <col class="docs-col-uploaded-by">
          <col class="docs-col-actions">
        </colgroup>

        <thead>
          <tr>
            <th>
              <wm-common-text class="th-text" [data]="{ text: 'File Name' }">
              </wm-common-text>
            </th>

            <th>
              <wm-common-text class="th-text" [data]="{ text: 'Uploaded On' }">
              </wm-common-text>
            </th>

            <th>
              <wm-common-text class="th-text" [data]="{ text: 'Uploaded By' }">
              </wm-common-text>
            </th>

            <th>
              <wm-common-text class="th-text" [data]="{ text: 'Actions' }">
              </wm-common-text>
            </th>
          </tr>
        </thead>

        <tbody>

          <ng-container *ngIf="documents?.length > 0; else noDocs">

            <tr *ngFor="let doc of documents">

              <td>

                <!-- VIEW MODE -->
                <ng-container *ngIf="!doc.editing; else editMode">

                  <a class="doc-link" [href]="doc.documentPath" target="_blank" rel="noopener noreferrer">
                    {{ doc.documentName }}
                  </a>

                </ng-container>

                <!-- EDIT MODE -->
                <ng-template #editMode>

                  <div class="edit-row">

                    <input type="text" class="edit-input" [(ngModel)]="doc.editDocumentName" [class.input-error]="doc.documentNameError" autofocus />

                    <!-- SAVE -->
                    <button mat-icon-button class="icon-btn save-icon" (click)="saveDocument(doc)">
                      <mat-icon>check</mat-icon>
                    </button>

                    <!-- CANCEL -->
                    <button mat-icon-button class="icon-btn cancel-icon" (click)="cancelEdit(doc)">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>
                  <!-- Start Code added by Sanchit on 09/08/2026 -->
                  <div *ngIf="doc.documentNameError" class="error-message">
                    File name cannot be blank.
                  </div>
                  <!-- End Code added by Sanchit on 09/08/2026 -->

                </ng-template>

              </td>



              <td>
                <wm-common-text [data]="{ text: (doc.createdOn | date:'MM/dd/yyyy') }">
                </wm-common-text>
              </td>

              <td>
                <wm-common-text [data]="{ text: doc.modifiedBy }">
                </wm-common-text>
              </td>

              <td>
                <button mat-button class="action-btn" [matMenuTriggerFor]="menu">
                  <wm-common-text class="action-text" [data]="{ text: 'Action' }">
                  </wm-common-text>
                </button>

                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editDocument(doc)">Edit</button>
                  <button mat-menu-item (click)="deleteDocument(doc.id)">Delete</button>
                </mat-menu>

              </td>

            </tr>

          </ng-container>

          <ng-template #noDocs>
            <tr>
              <td colspan="4" class="no-docs-cell">
                <wm-common-text [data]="{ text: 'No documents found' }">
                </wm-common-text>
              </td>
            </tr>
          </ng-template>

        </tbody>

      </table>
      </div>

      <!-- <div class="footer-actions" *ngIf="documents?.length > 0">

        <button mat-flat-button class="cancel-btn">
          CANCEL
        </button>

        <button mat-flat-button class="save-btn">
          SAVE
        </button>

      </div> -->

    </div>

  </div>
</div>

